export default {"src":"/_next/static/image/assets/img/svg/next.6fc5129055c95e30690574fe734cfe57.svg","height":48,"width":48};